import { Component, type ErrorInfo, type ReactNode } from 'react';

import { SiteDownPage } from './components/SiteDownPage';
import { isXmlLikeInfrastructureText, navigateToStaticSiteDown } from './siteDown';

type Props = { children: ReactNode };
type State = { hasError: boolean };

export class MarketingErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    const text = [error instanceof Error ? error.message : String(error), info.componentStack]
      .filter(Boolean)
      .join('\n');
    if (isXmlLikeInfrastructureText(text)) {
      navigateToStaticSiteDown();
    }
  }

  render() {
    if (this.state.hasError) {
      return <SiteDownPage />;
    }
    return this.props.children;
  }
}
